import { useContext } from 'react'

import { ToastContext } from '@reveni-io/reveni-ui'

import SaveChangesButtons from '@/common/components/SaveChangesButtons/SaveChangesButtons'
import UnsavedChangesAlert from '@/common/components/UnsavedChangesAlert/UnsavedChangesAlert'
import { userPermissions } from '@/common/constants'
import AppContext from '@/common/context/app.context'
import useUserPermissions from '@/common/hooks/useUserPermissions/useUserPermissions'

import useReturnWidgetConfiguration from './hooks/useReturnWidgetConfiguration/useReturnWidgetConfiguration'
import ReturnWidgetConfiguration from './ReturnWidgetConfiguration/ReturnWidgetConfiguration'
import ReveniWidgetConfigurationPageSkeleton from './ReveniWidgetConfigurationPageSkeleton/ReveniWidgetConfigurationPageSkeleton'
import * as Styles from './styles'

const ReveniWidgetConfigurationPage = () => {
  const { info } = useContext(AppContext)
  const { setToastInfo } = useContext(ToastContext)
  const { hasPermission } = useUserPermissions()
  const supportedLanguages = info?.selectedStore?.supported_languages || ['en']

  const {
    widgetPreferences,
    applyingWidgetPreferences,
    backgroundColor,
    setBackgroundColor,
    textColor,
    setTextColor,
    linkColor,
    setLinkColor,
    setLogoType,
    gettingWidgetPreferences,
    hasChanges,
    revertChanges,
    setCustomTexts,
    customTexts,
    useCustomText,
    setUseCustomText,
    scriptInfo,
    divInfo,
    onSave,
  } = useReturnWidgetConfiguration({
    storeId: info.selectedStore.id,
    supportedLanguages,
    storeProvider: info.selectedStore.provider,
    setToastInfo,
  })

  if (gettingWidgetPreferences) {
    return <ReveniWidgetConfigurationPageSkeleton />
  }

  return (
    <Styles.Container>
      {hasChanges && <UnsavedChangesAlert hasPermission={hasPermission(userPermissions.editExtra)} />}
      <ReturnWidgetConfiguration
        backgroundColor={backgroundColor}
        textColor={textColor}
        linkColor={linkColor}
        onChangeBackgroundColor={setBackgroundColor}
        onChangeTextColor={setTextColor}
        onChangeLinkColor={setLinkColor}
        onChangeLogoType={setLogoType}
        widgetPreferences={widgetPreferences}
        store={info?.selectedStore}
        supportedLanguages={supportedLanguages}
        onChangeCustomTexts={setCustomTexts}
        customTexts={customTexts}
        useCustomText={useCustomText}
        onChangeUseCustomText={setUseCustomText}
        divInfo={divInfo}
        scriptInfo={scriptInfo}
      />
      <SaveChangesButtons
        hasChanges={hasPermission(userPermissions.editExtra) && hasChanges}
        onSave={onSave}
        onRevertChanges={revertChanges}
        loading={applyingWidgetPreferences || gettingWidgetPreferences}
        disabled={applyingWidgetPreferences || gettingWidgetPreferences}
      />
    </Styles.Container>
  )
}

export default ReveniWidgetConfigurationPage
